import { CategoryBE, CategoryUI } from "../constants/category.constants"

const fromBEtoUIModel = (category: CategoryBE): CategoryUI => {
  return {
    isCustom: category.isCustomCategory,
    techSpendActive: category.TechVisibility,
    storefrontActive: category.StoreVisibility,
    subCategories: category?.SubCatList?.map(fromBEtoUIModel),
    categoryId: category.Id,
    categoryName: category.Name,
    categoryHexColor: category.ColorCode,
    SortOrder: category.SortOrder,
    parentCategoryId: category.parentCategoryId,
    UsedInStoreFront: category.UsedInStoreFront,
    UsedInTechSpend: category.UsedInTechSpend,
    Tooltip: category.Tooltip,
  }
}

const fromUItoBEModel = (category: CategoryUI): CategoryBE => {
  return {
    Id: category.categoryId,
    Name: category.categoryName,
    ColorCode: category.categoryHexColor,
    isCustomCategory: category.isCustom,
    TechVisibility: category.techSpendActive,
    StoreVisibility: category.storefrontActive,
    SortOrder: category.SortOrder,
    SubCatList: category.subCategories?.map(fromUItoBEModel),
    parentCategoryId: category.parentCategoryId,
    UsedInStoreFront: category.UsedInStoreFront,
    UsedInTechSpend: category.UsedInTechSpend,
    Tooltip: category.Tooltip,
  }
}

export const categoryUtils = {
  fromBEtoUIModel,
  fromUItoBEModel,
}
